module.exports = __webpack_public_path__ + "static/6305-woodrose-21-365df7696b417344072e39ecc280074f.jpg";